import { useTranslation } from "react-i18next";

import { Dropdown } from "components";
import "modules/DealerReports/components/DealerQualityChecksTabular/DealerQualityChecksTabular.scss";
import { useDealerQualityChecksFilterOptions } from "modules/DealerReports/components/DealerQualityChecksTabular/hooks";

import type { QUESTION_RESULT_STATUSES } from "models";

type FilterOption = { id: number; name: string };

type DealerQualityChecksTabularFiltersProps = {
  mechanics: FilterOption[];
  qcOfficers: FilterOption[];
  dealerLocations: FilterOption[];
  qualityChecklists: FilterOption[];
  mechanicId?: number;
  locationId?: number;
  qcOfficerId?: number;
  qcStatus?: QUESTION_RESULT_STATUSES;
  qcChecklistId?: number;
  setMechanicId: (value?: number) => void;
  setLocationId: (value?: number) => void;
  setQcOfficerId: (value?: number) => void;
  setQcStatus: (value?: QUESTION_RESULT_STATUSES) => void;
  setQcChecklistId: (value?: number) => void;
};

export const DealerQualityChecksTabularFilters = ({
  mechanics,
  qcOfficers,
  dealerLocations,
  qualityChecklists,
  mechanicId,
  locationId,
  qcOfficerId,
  qcStatus,
  qcChecklistId,
  setMechanicId,
  setLocationId,
  setQcOfficerId,
  setQcStatus,
  setQcChecklistId
}: DealerQualityChecksTabularFiltersProps) => {
  const { t } = useTranslation();

  const { mechanicsDropdownOptions, locationsDropdownOptions, qcOfficersDropdownOptions, qcStatusesDropdownOptions, qcChecklistsDropdownOptions } =
    useDealerQualityChecksFilterOptions({
      mechanics,
      qcOfficers,
      dealerLocations,
      qualityChecklists
    });

  return (
    <div className="details-card-filters-container">
      <Dropdown
        noResultsMessage={t("v8_no_qc_statuses", "No QC statuses")}
        placeholder={t("v8_select_qc_status", "Select QC status")}
        options={qcStatusesDropdownOptions}
        onChange={setQcStatus}
        selectOnBlur={false}
        value={qcStatus}
        fluid
        selection
        clearable
      />
      <Dropdown
        noResultsMessage={t("v8_no_mechanics", "No mechanics")}
        placeholder={t("v8_select_mechanic", "Select Mechanic")}
        options={mechanicsDropdownOptions}
        onChange={setMechanicId}
        selectOnBlur={false}
        value={mechanicId}
        fluid
        selection
        clearable
      />
      <Dropdown
        noResultsMessage={t("v8_no_qc_officers", "No QC Officers")}
        placeholder={t("v8_select_qc_officer", "Select QC Officer")}
        options={qcOfficersDropdownOptions}
        onChange={setQcOfficerId}
        selectOnBlur={false}
        value={qcOfficerId}
        fluid
        selection
        clearable
      />
      <Dropdown
        noResultsMessage={t("v8_no_locations", "No locations")}
        placeholder={t("v8_select_location", "Select Location")}
        options={locationsDropdownOptions}
        onChange={setLocationId}
        selectOnBlur={false}
        value={locationId}
        fluid
        selection
        clearable
      />
      <Dropdown
        noResultsMessage={t("v8_no_qc_checklist", "No QC Checklists")}
        placeholder={t("v8_select_qc_checklist", "Select QC Checklist")}
        options={qcChecklistsDropdownOptions}
        onChange={setQcChecklistId}
        selectOnBlur={false}
        value={qcChecklistId}
        fluid
        selection
        clearable
      />
    </div>
  );
};
